export type DropdownItem = { id: string | number; label: string };

// Medications
export const medications: DropdownItem[] = [
  // Pain relief & musculoskeletal
  { id: 'Paracetamol', label: 'Paracetamol (Panadol)' },
  { id: 'Ibuprofen', label: 'Ibuprofen (Nurofen)' },
  { id: 'Codeine', label: 'Codeine (Panadeine)' },
  { id: 'Tramadol', label: 'Tramadol (Tramal)' },
  { id: 'Naproxen', label: 'Naproxen (Naprogesic)' },
  { id: 'Amitriptyline', label: 'Amitriptyline (Endep)' },
  { id: 'Duloxetine', label: 'Duloxetine (Cymbalta)' },
  { id: 'Pregabalin', label: 'Pregabalin (Lyrica)' },
  { id: 'Milnacipran', label: 'Milnacipran (Ixprim)' },
  { id: 'Cyclobenzaprine', label: 'Cyclobenzaprine (Flexeril)' },
  { id: 'Celecoxib', label: 'Celecoxib (Celebrex)' },
  { id: 'Diclofenac', label: 'Diclofenac (Voltaren)' },
  { id: 'Oxycodone', label: 'Oxycodone (Endone, OxyContin)' },
  { id: 'Tapentadol', label: 'Tapentadol (Palexia)' },
  { id: 'Gabapentin', label: 'Gabapentin (Neurontin)' },

  // Diabetes
  { id: 'Metformin', label: 'Metformin (Diabex)' },
  { id: 'Gliclazide', label: 'Gliclazide (Diamicron)' },
  { id: 'Sitagliptin', label: 'Sitagliptin (Januvia)' },
  { id: 'Empagliflozin', label: 'Empagliflozin (Jardiance)' },
  { id: 'Liraglutide', label: 'Liraglutide (Victoza)' },
  { id: 'Semaglutide', label: 'Semaglutide (Ozempic)' },
  { id: 'Insulin glargine', label: 'Insulin glargine (Lantus)' },
  { id: 'Insulin aspart', label: 'Insulin aspart (NovoRapid)' },
  { id: 'Insulin lispro', label: 'Insulin lispro (Humalog)' },
  { id: 'Insulin detemir', label: 'Insulin detemir (Levemir)' },

  // Cardiovascular & blood pressure
  { id: 'Amlodipine', label: 'Amlodipine (Norvasc)' },
  { id: 'Ramipril', label: 'Ramipril (Tritace)' },
  { id: 'Irbesartan', label: 'Irbesartan (Aprovel)' },
  { id: 'Lisinopril', label: 'Lisinopril (Zestril)' },
  { id: 'Losartan', label: 'Losartan (Cozaar)' },
  { id: 'Hydrochlorothiazide', label: 'Hydrochlorothiazide (Oretic)' },
  { id: 'Bisoprolol', label: 'Bisoprolol (Cardicor)' },

  // Respiratory & asthma/COPD
  { id: 'Salbutamol', label: 'Salbutamol (Ventolin)' },
  { id: 'Budesonide', label: 'Budesonide (Pulmicort)' },
  { id: 'Fluticasone', label: 'Fluticasone (Flixotide)' },
  { id: 'Montelukast', label: 'Montelukast (Singulair)' },
  { id: 'Formoterol', label: 'Formoterol (Oxis)' },
  { id: 'Tiotropium', label: 'Tiotropium (Spiriva)' },
  { id: 'Budesonide/Formoterol', label: 'Budesonide/Formoterol (Symbicort)' },
  { id: 'Ipratropium', label: 'Ipratropium (Atrovent)' },

  // Cholesterol & lipids
  { id: 'Atorvastatin', label: 'Atorvastatin (Lipitor)' },
  { id: 'Simvastatin', label: 'Simvastatin (Zocor)' },
  { id: 'Rosuvastatin', label: 'Rosuvastatin (Crestor)' },
  { id: 'Pravastatin', label: 'Pravastatin (Pravachol)' },
  { id: 'Ezetimibe', label: 'Ezetimibe (Ezetrol)' },

  // Heart failure & diuretics
  { id: 'Enalapril', label: 'Enalapril (Renitec)' },
  { id: 'Metoprolol', label: 'Metoprolol (Betaloc)' },
  { id: 'Furosemide', label: 'Furosemide (Lasix)' },
  { id: 'Spironolactone', label: 'Spironolactone (Aldactone)' },

  // Thyroid
  { id: 'Levothyroxine', label: 'Levothyroxine (Oroxine)' },
  { id: 'Liothyronine', label: 'Liothyronine (Tertroxin)' },

  // Bone health & osteoporosis
  { id: 'Alendronate', label: 'Alendronate (Fosamax)' },
  { id: 'Risedronate', label: 'Risedronate (Actonel)' },
  { id: 'Denosumab', label: 'Denosumab (Prolia)' },
  { id: 'Calcium carbonate', label: 'Calcium carbonate (Caltrate)' },

  // Migraine
  { id: 'Sumatriptan', label: 'Sumatriptan (Imigran)' },
  { id: 'Rizatriptan', label: 'Rizatriptan (Maxalt)' },
  { id: 'Propranolol', label: 'Propranolol (Inderal)' },
  { id: 'Topiramate', label: 'Topiramate (Topamax)' },
  { id: 'Fremanezumab', label: 'Fremanezumab (Ajovy)' },

  // Antidepressants & anxiety
  { id: 'Sertraline', label: 'Sertraline (Zoloft)' },
  { id: 'Escitalopram', label: 'Escitalopram (Lexapro)' },
  { id: 'Alprazolam', label: 'Alprazolam (Kalma)' },
  { id: 'Lorazepam', label: 'Lorazepam (Ativan)' },
  { id: 'Buspirone', label: 'Buspirone (Buspar)' },
  { id: 'Venlafaxine', label: 'Venlafaxine (Efexor)' },
  { id: 'Fluoxetine', label: 'Fluoxetine (Prozac)' },
  { id: 'Paroxetine', label: 'Paroxetine (Aropax)' },
  { id: 'Citalopram', label: 'Citalopram (Cipramil)' },
  { id: 'Bupropion', label: 'Bupropion (Zyban)' },
  { id: 'Mirtazapine', label: 'Mirtazapine (Avanza)' },

  // Mood stabilisers & antipsychotics
  { id: 'Lithium', label: 'Lithium (Lithicarb)' },
  { id: 'Valproate', label: 'Valproate (Epilim)' },
  { id: 'Quetiapine', label: 'Quetiapine (Seroquel)' },
  { id: 'Olanzapine', label: 'Olanzapine (Zyprexa)' },
  { id: 'Lamotrigine', label: 'Lamotrigine (Lamictal)' },
  { id: 'Risperidone', label: 'Risperidone (Risperdal)' },
  { id: 'Haloperidol', label: 'Haloperidol (Haldol)' },
  { id: 'Clozapine', label: 'Clozapine (Clozaril)' },
  { id: 'Aripiprazole', label: 'Aripiprazole (Abilify)' },
  { id: 'Carbamazepine', label: 'Carbamazepine (Tegretol)' },

  // Sleep & insomnia
  { id: 'Zolpidem', label: 'Zolpidem (Stilnox)' },
  { id: 'Zopiclone', label: 'Zopiclone (Imovane)' },
  { id: 'Melatonin', label: 'Melatonin (Circadin)' },
  { id: 'Temazepam', label: 'Temazepam (Normison)' },
  { id: 'Doxylamine', label: 'Doxylamine (Restavit)' },
  { id: 'Trazodone', label: 'Trazodone (Molipaxin)' },
  { id: 'Clonazepam', label: 'Clonazepam (Rivotril)' },

  // Gastrointestinal
  { id: 'Ondansetron', label: 'Ondansetron (Zofran)' },
  { id: 'Metoclopramide', label: 'Metoclopramide (Maxolon)' },
  { id: 'Omeprazole', label: 'Omeprazole (Losec)' },
  { id: 'Pantoprazole', label: 'Pantoprazole (Somac)' },

  // Hormones & contraception
  { id: 'Norethisterone', label: 'Norethisterone (Primolut N)' },
  { id: 'Estradiol', label: 'Estradiol (Estradot, Progynova)' },
  { id: 'Progesterone', label: 'Progesterone (Prometrium)' },
  { id: 'Levonorgestrel/ethinylestradiol', label: 'Levonorgestrel/ethinylestradiol (Levlen, Microgynon)' },

  // High Risk Med Vascular
  { id: 'Clopidogrel', label: 'Clopidogrel (Plavix)' },
  { id: 'Ticagrelor', label: 'Ticagrelor (Brilinta)' },
  { id: 'Estradot, Progynova', label: 'Estradot, Progynova (Eliquis)' },
  { id: 'Dabigatran', label: 'Dabigatran (Pradaxa)' },
  { id: 'Rivaroxaban', label: 'Rivaroxaban (Xarelto)' },
  { id: 'Warfarin', label: 'Warfarin (Marevan, Coumadin)' },
  { id: 'Apixaban', label: 'Apixaban (Eliquis)' },

  // High Risk Med Antirheumatics/Immunosuppressants/MABs
  { id: 'Hydroxychloroquine', label: 'Hydroxychloroquine (Plaquenil)' },
  { id: 'Azathioprine', label: 'Azathioprine (Imuran)' },
  { id: 'Leflunomide', label: 'Leflunomide (Arava)' },
  { id: 'Methoblastin', label: 'Methoblastin (Methotrexate)' },
  { id: 'Tacrolimus', label: 'Tacrolimus (Prograf)' },
  { id: 'Cyclosporine', label: 'Cyclosporine (Neoral)' },
  { id: 'Sirolimus', label: 'Sirolimus (Rapamune)' },
  { id: 'Mycophenolate', label: 'Mycophenolate (CellCept)' },
  { id: 'Mercaptopurine', label: 'Mercaptopurine (Purinethol)' },
  { id: 'Natalizumab', label: 'Natalizumab (Tysabri)' },
  { id: 'Tocilizumab', label: 'Tocilizumab (RoActemra)' },
  { id: 'Adalimumab', label: 'Adalimumab (Humira)' },
  { id: 'Ixekizumab', label: 'Ixekizumab (Taltz)' },
  { id: 'Golimumab', label: 'Golimumab (Simponi)' },
  { id: 'Infliximab', label: 'Infliximab (Remicade)' },
  { id: 'Ipilimumab', label: 'Ipilimumab (Yervoy)' },
  { id: 'Nivolumab', label: 'Nivolumab (Opdivo)' },
  { id: 'Secukinumab', label: 'Secukinumab (Cosentyx)' },

  // High Risk Med Antipsychotic
  { id: 'Amisulpride', label: 'Amisulpride (Solian)' },
  { id: 'Asenapine', label: 'Asenapine (Saphris)' },
  { id: 'Brexpiprazole', label: 'Brexpiprazole (Rexulti)' },
  { id: 'Cariprazine', label: 'Cariprazine (Vraylar)' },
  { id: 'Chlorpromazine', label: 'Chlorpromazine (Largactil)' },
  { id: 'Flupentixol', label: 'Flupentixol (Depixol)' },
  { id: 'Fluphenazine', label: 'Fluphenazine (Modecate)' },
  { id: 'Iloperidone', label: 'Iloperidone (Fanapt)' },
  { id: 'Lurasidone', label: 'Lurasidone (Latuda)' },
  { id: 'Paliperidone', label: 'Paliperidone (Invega)' },
  { id: 'Periciazine', label: 'Periciazine (Neuleptil)' },
  { id: 'Prochlorperazine', label: 'Prochlorperazine (Stemetil)' },
  { id: 'Sertindole', label: 'Sertindole (Serdolect)' },
  { id: 'Sodium Valproate', label: 'Sodium Valproate (Epilim)' },
  { id: 'Thioridazine', label: 'Thioridazine (Melleril)' },
  { id: 'Trifluoperazine', label: 'Trifluoperazine (Stelazine)' },
  { id: 'Ziprasidone', label: 'Ziprasidone (Zeldox)' },
  { id: 'Zuclopenthixol', label: 'Zuclopenthixol (Clopixol)' },

  // High Risk Med OTP
  { id: 'Naltrexone', label: 'Naltrexone (ARX-Naltrexone)' },
  { id: 'Buprenorphine', label: 'Buprenorphine (Norspan, Subutex)' },
  { id: 'Methadone', label: 'Methadone' },

  // Fallback
  { id: "My medication isn't listed", label: "My medication isn't listed" },
];

// Dosages
export const medicationDosage: DropdownItem[] = [
  { id: 'other', label: 'Other' },
  { id: '<1mg', label: '< 1mg' },
  { id: '~1mg', label: '~1mg' },
  { id: '~2mg', label: '~2mg' },
  { id: '~5mg', label: '~5mg' },
  { id: '~10mg', label: '~10mg' },
  { id: '~20mg', label: '~20mg' },
  { id: '~50mg', label: '~50mg' },
  { id: '~100mg', label: '~100mg' },
  { id: '~150mg', label: '~150mg' },
  { id: '~200mg', label: '~200mg' },
  { id: '~250mg', label: '~250mg' },
  { id: '~500mg', label: '~500mg' },
  { id: '~850mg', label: '~850mg' },
  { id: '~1000mg', label: '~1000mg' },
  { id: '>1200mg', label: '> 1200mg' },
];

// Frequencies
export const medicationFrequency: DropdownItem[] = [
  { id: 'other', label: 'Other' },
  { id: 'Once daily', label: 'Once daily' },
  { id: 'Twice daily', label: 'Twice daily' },
  { id: 'Three times daily', label: 'Three times daily' },
  { id: 'Four times daily', label: 'Four times daily' },
  { id: 'PRN', label: 'As needed (PRN)' },
  { id: 'Weekly', label: 'Weekly' },
];

// Conditions
export const medicalConditions: DropdownItem[] = [
  { id: 13, label: `Women's Health` },
  { id: 1, label: 'PTSD' },
  { id: 2, label: 'Depression' },
  { id: 3, label: 'Anxiety' },
  { id: 4, label: 'Insomnia' },
  { id: 5, label: 'Chronic Pain' },
  { id: 6, label: 'GI Issues' },
  { id: 7, label: 'Neurological/Neurodegenerative' },
  { id: 8, label: 'ADHD' },
  { id: 12, label: 'Autism' },
  { id: 9, label: 'Oncology' },
  { id: 10, label: 'Palliative Care' },
  { id: 11, label: "My condition isn't listed" },
];

// Treatment durations
export const treatmentDurations: DropdownItem[] = [
  { id: 'Less than 3 months', label: 'Less than 3 months' },
  { id: '3 - 6 months', label: '3 - 6 months' },
  { id: '6 - 12 months', label: '6 - 12 months' },
  { id: 'More than a year', label: 'More than a year' },
];
